/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ProductsJsmKbPermissionsType from '@jira/spa-apps__admin-pages-product-jsm-kb-permissions/src/ProductsJsmKbPermissionsType.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyProductsJsmKbPermissions: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof ProductsJsmKbPermissionsType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-products-jsm-kb-permissions", jiraSpaEntry: "async-products-jsm-kb-permissions" */ '@jira/spa-apps__admin-pages-product-jsm-kb-permissions/src/ProductsJsmKbPermissionsType.tsx'
		),
	),
);

const AsyncProductsJsmKbPermissions = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProductsJsmKbPermissions}
		pageId="products-jsm-kb-permissions"
		shouldShowSpinner={false}
	/>
);

export default AsyncProductsJsmKbPermissions;
